import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const modal = css`
  padding: 10px 20px 0;
`;

export const select = css`
  margin: 10px 0 40px;
  min-width: 300px;
  width: 45%;
`;

export const recurrences = css`
  margin: 10px 0 40px;
  display: inline-flex;
  flex-flow: wrap;
  width: 100%;
  gap: 20px;
`;

export const recurrence = css`
  display: flex;
  padding: 20px;
  border-radius: 5px;
  border: solid 1px ${colors.gray.light};
  box-sizing: border-box;
  width: calc(50% - 10px);
  gap: 5px;

  > label {
    width: 34%;
  }

  > span {
    width: 66%;
  }
`;

export const checkboxes = css`
  margin-top: 20px;
`;

export const infoSection = css`
  display: flex;
  margin: 40px 0;
`;

export const infoBlock = css`
  width: 20%;

  :not(:first-child) {
    margin-left: 20px;
  }
  :nth-last-child(2) {
    width: 20%;
  }
  :last-child {
    width: 40%;
  }

  > span {
    margin-bottom: 10px;
  }

  > div {
    width: 100%;
  }
`;

export const errorLabel = css`
  margin-top: 5px;
`;

const placeholder = css`
  content: "";
  border: none;
  margin: 30px 0 0;
`;

export const placeholderWithoutTextButton = css`
  ${placeholder} margin-bottom: 30px;
`;

export const loading = css`
  margin: 60px auto;
  width: 100%;
`;

export const dashcamOptionIcon = css`
  color: ${colors.gray.dark};
`;
